import { notification } from "antd";

const OpenNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message: message,
    description: description,
    //showProgress: true,
    duration: 4,
  });
};

export default OpenNotificationWithIcon;
